import styled from 'styled-components'

import { fontWeightLight } from '../../../../utils/style-utils'

export const Title = styled.span`
  font-size: 12px;
  font-weight: ${fontWeightLight};
`
